import { render } from "./SurveyQuestionMultiple.vue?vue&type=template&id=27d545b1&scoped=true"
import script from "./SurveyQuestionMultiple.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionMultiple.vue?vue&type=script&lang=js"

import "./SurveyQuestionMultiple.vue?vue&type=style&index=0&id=27d545b1&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d545b1"]])

export default __exports__